import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation} from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import { VisionPage } from "./pages/VisionPage";
import { LeadershipPage } from "./pages/LeaderShipPage";
import { JourneyPage } from "./pages/Journey";
import { Awards } from "./pages/AwardsPage";
import { ProjectsPage } from "./pages/Projects";
import { ProjectDetailPage } from "./components/projectDetails";
import { SpotlightPage } from "./pages/Spotlight";
import { HumansOfGillcoPage } from "./pages/Culture";
import { CSRPage } from "./pages/CSR";
import { EventsPage } from "./pages/Events";
import { CareersPage } from "./pages/Careers";
import { ContactPage } from "./pages/Contact";
import PageLayout from "./pages/PageLayout";
import { Thankyou } from "./pages/ThankYou";
import { useEffect } from "react";
import SEO from "./components/ui/seo";
;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
function App() {
  return (
    <div className="App">
     
        <BrowserRouter>
        <SEO />
        <ScrollToTop />
        <Routes>

          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<PageLayout><AboutUsPage /></PageLayout>} />
          <Route path="/vision" element={<PageLayout><VisionPage /></PageLayout>} />
          <Route path="/leadership" element={<PageLayout><LeadershipPage /></PageLayout>} />
          <Route path="/journey" element={<PageLayout><JourneyPage /></PageLayout>} />
          <Route path="/awards" element={<PageLayout><Awards /></PageLayout>} />
          <Route path="/projects" element={<PageLayout><ProjectsPage /></PageLayout>} />
          <Route path="/projects/featured" element={<PageLayout><ProjectsPage /></PageLayout>} />
          <Route path="/projects/residential" element={<PageLayout><ProjectsPage /></PageLayout>} />
          <Route path="/projects/industrial" element={<PageLayout><ProjectsPage /></PageLayout>} />
          <Route path="/projects/:projectId" element={<PageLayout><ProjectDetailPage /></PageLayout>} />
          <Route path="/spotlight" element={<PageLayout><SpotlightPage /></PageLayout>} />
          <Route path="/culture/humans" element={<PageLayout><HumansOfGillcoPage /></PageLayout>} />
          <Route path="/culture/csr" element={<PageLayout><CSRPage /></PageLayout>} />
          {/* <Route path="/culture/events" element={<PageLayout><EventsPage /></PageLayout>} /> */}
          <Route path="/careers" element={<PageLayout><CareersPage /></PageLayout>} />
          <Route path="/contact" element={<PageLayout><ContactPage /></PageLayout>} />
          <Route path="/thankyou" element={<Thankyou />} />
          </Routes>
          </BrowserRouter>
          
    </div>
  );
}

export default App;
